let canvas, ctx;
let snake, food, direction, gameInterval;
let gridSize = 20;
let isGameActive = false;
let score = 0;
let lastDirection = 'RIGHT'; // Dirección inicial válida
let directionQueue = []; // Cola de direcciones para teclas rápidas

// Iniciar el juego
function startGame() {
  if (isGameActive) return; // Evita iniciar el juego más de una vez

  isGameActive = true;
  canvas = document.getElementById('gameCanvas');
  ctx = canvas.getContext('2d');
  canvas.width = 400;
  canvas.height = 400;

  // Inicializa la serpiente
  snake = [{x: 160, y: 160}, {x: 140, y: 160}, {x: 120, y: 160}];
  food = {x: randomPosition(), y: randomPosition()};
  direction = 'RIGHT';
  
  // Ocultar el banner y mostrar el juego
  document.querySelector('.image-banner').style.display = 'none';
  document.getElementById('game-container').style.display = 'block';
  
  // Iniciar intervalo para actualizar el juego
  gameInterval = setInterval(updateGame, 100);

  // Escuchar teclas para el movimiento
  window.addEventListener('keydown', changeDirection);
  document.getElementById('restart-btn').disabled = true; // Deshabilitar el botón de reiniciar mientras el juego está activo
}

// Cambiar la dirección con las teclas
function changeDirection(e) {
  // Prevenir el comportamiento por defecto (desplazamiento de la página)
  e.preventDefault();

  if (e.key === "ArrowUp" && lastDirection !== 'DOWN') {
    directionQueue.push('UP');
  } else if (e.key === "ArrowDown" && lastDirection !== 'UP') {
    directionQueue.push('DOWN');
  } else if (e.key === "ArrowLeft" && lastDirection !== 'RIGHT') {
    directionQueue.push('LEFT');
  } else if (e.key === "ArrowRight" && lastDirection !== 'LEFT') {
    directionQueue.push('RIGHT');
  }
}

// Actualizar el juego cada intervalo
function updateGame() {
  if (directionQueue.length > 0) {
    // Procesar la nueva dirección
    direction = directionQueue.shift(); // Cambiar la dirección
  }

  moveSnake();
  checkCollision();
  checkFoodCollision();
  draw();
}

// Mover la serpiente
function moveSnake() {
  let head = Object.assign({}, snake[0]);
  
  if (direction === 'UP') head.y -= gridSize;
  if (direction === 'DOWN') head.y += gridSize;
  if (direction === 'LEFT') head.x -= gridSize;
  if (direction === 'RIGHT') head.x += gridSize;
  
  snake.unshift(head); // Agregar nuevo segmento de cabeza

  // Eliminar la última parte si no comió
  if (head.x !== food.x || head.y !== food.y) {
    snake.pop();
  } else {
    food = {x: randomPosition(), y: randomPosition()}; // Reaparece la comida
    score++; // Incrementar el puntaje
  }

  // Actualizar la última dirección solo cuando la serpiente se mueve
  lastDirection = direction;
}

// Dibujar el juego
function draw() {
  ctx.clearRect(0, 0, canvas.width, canvas.height); // Limpiar el canvas

  // ------------------------------
  // Dibujar la serpiente en rojo neón con glow
  // ------------------------------
  ctx.shadowColor = "#ff073a";  // rojo neón para glow
  ctx.shadowBlur = 10;           // intensidad del glow
  ctx.fillStyle = "#ff073a";     // color principal de la serpiente

  for (let i = 0; i < snake.length; i++) {
    ctx.fillRect(snake[i].x, snake[i].y, gridSize, gridSize);
  }

  // ------------------------------
  // Dibujar la comida
  // ------------------------------
  ctx.shadowColor = "#ff4d6d";  // rojo más brillante para comida
  ctx.shadowBlur = 15;           // más glow
  ctx.fillStyle = "#ff1a5c";     // color de la comida
  ctx.fillRect(food.x, food.y, gridSize, gridSize);

  // ------------------------------
  // Reset shadow para otros elementos
  // ------------------------------
  ctx.shadowBlur = 0;

  // Actualizar el puntaje en pantalla
  document.getElementById('score').innerText = `Puntaje: ${score}`;
}




// Revisar si la serpiente se colisiona con los bordes o consigo misma
function checkCollision() {
  let head = snake[0];

  if (head.x < 0 || head.x >= canvas.width || head.y < 0 || head.y >= canvas.height || isSelfCollision(head)) {
    endGame();
  }
}

// Colisión con el cuerpo de la serpiente
function isSelfCollision(head) {
  for (let i = 1; i < snake.length; i++) {
    if (snake[i].x === head.x && snake[i].y === head.y) {
      return true;
    }
  }
  return false;
}

// Verificar si la serpiente comió la comida
function checkFoodCollision() {
  let head = snake[0];
  if (head.x === food.x && head.y === food.y) {
    food = {x: randomPosition(), y: randomPosition()};
  }
}

// Obtener una posición aleatoria para la comida
function randomPosition() {
  return Math.floor(Math.random() * (canvas.width / gridSize)) * gridSize;
}

// Terminar el juego
function endGame() {
  clearInterval(gameInterval);  // Detener el ciclo de actualización del juego
  isGameActive = false;
  document.getElementById('restart-btn').style.display = 'block';  // Mostrar el botón de reinicio
  document.getElementById('restart-btn').disabled = false;  // Habilitar el botón de reiniciar
  window.removeEventListener('keydown', changeDirection);  // Eliminar el evento de teclas
}

// Reiniciar el juego
function restartGame() {
  // Deshabilitar el botón para evitar que se presione mientras se reinicia
  document.getElementById('restart-btn').disabled = true;

  // Limpiar el canvas y resetear el puntaje
  score = 0;
  document.getElementById('score').innerText = `Puntaje: ${score}`;

  // Detener cualquier intervalo previo
  clearInterval(gameInterval);

  // Resetear los estados
  snake = [{x: 160, y: 160}, {x: 140, y: 160}, {x: 120, y: 160}];
  food = {x: randomPosition(), y: randomPosition()};
  direction = 'RIGHT';
  directionQueue = [];

  // Reiniciar el juego
  setTimeout(() => {
    startGame(); // Reiniciar el ciclo del juego con un pequeño retraso
  }, 100); // Retraso mínimo para asegurar que todo se ha limpiado correctamente
}


